export interface ToolLink {
  to: string
  labelKey: string
}

/** The free tool pages listed in the nav "Tools" dropdown and its mobile drawer sub-list. */
export const TOOL_LINKS: ToolLink[] = [
  {to: '/icon-generator', labelKey: 'landing.nav.iconGenerator'},
  {to: '/qr-generator', labelKey: 'landing.nav.qrGenerator'},
  {to: '/image-converter', labelKey: 'landing.nav.imageConverter'},
  {to: '/video-to-gif', labelKey: 'landing.nav.videoToGif'},
  {to: '/app-store-creative-assets', labelKey: 'landing.nav.creativeAssets'},
]
